<template>
	<div id="app">
		<v-app id="inspire">
			<v-toolbar light fixed clipped-left app dark color="blue-grey darken-3">
                <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
                <v-toolbar-title class="headline font-weight-black text-uppercase deep-orange--text">Service Scheduler</v-toolbar-title>
                <v-spacer></v-spacer>

                <v-toolbar-title v-if="user" class="subheading font-weight-medium justify-center">
                    <v-menu v-if="user" offset-y>
                        <template v-slot:activator="{ on }">
                            <v-card-title v-if="user" v-on="on" class="subheading font-weight-bold justify-center text-uppercase">
                                {{branch}} 
                                <v-spacer></v-spacer>
                                <v-icon color="green lighten-1">arrow_drop_down</v-icon>
                            </v-card-title>
                        </template>

                        <v-card dark>
                            <v-list class="blue-grey darken-4">
                                <v-list-tile avatar>
                                    <v-list-tile-avatar>
                                        <v-avatar v-if="user.photo">
                                            <img :src="user.photo">
                                        </v-avatar>
                                        <v-avatar v-else>
                                            <v-icon size="40">portrait</v-icon>
                                        </v-avatar>
                                    </v-list-tile-avatar>
                        
                                    <v-list-tile-content>
                                        <v-list-tile-title>{{user.email}}</v-list-tile-title>
                                        <v-list-tile-sub-title class="text-uppercase">{{role}}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-list>
                    
                            <v-divider></v-divider>
                    
                            <v-list class="blue-grey darken-4">
                                <v-list-tile @click="(goToPage('logout'),drawer=false)">
                                    <v-list-tile-action>
                                    <v-icon small color="green lighten-1">exit_to_app</v-icon></v-list-tile-action>
                                    <v-list-tile-title class="body-2 font-weight-medium grey--text text--darken-1">LOG-OUT</v-list-tile-title>
                                </v-list-tile>
                            </v-list>
                        </v-card>
                    </v-menu>
                </v-toolbar-title>
			</v-toolbar>

            <v-navigation-drawer v-model="drawer" class="blue-grey darken-4" clipped app dark>
                <div v-show="showCalendar" class="text-xs-center">
                    <v-date-picker color="primary" header-color="red" v-model="picker" :allowed-dates="(allowedDates)"></v-date-picker>
                </div>

                <v-list>
                    <v-container>
                        <v-list-tile :class="RequestAppointmentColor" @click="(goToPage('service-approval'),showCalendar=false)">
                            <v-list-tile-action><v-icon small color="green lighten-1">inbox</v-icon></v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title class="body-2 font-weight-regular">
                                    Appointment Request
                                    <v-badge class="pt-1" color="red">
                                        <template v-slot:badge>
                                        <span v-if="requests.length>0">{{requests.length}}</span>
                                        </template>
                                    </v-badge>
                                </v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>

                        <v-list-tile :class="BranchTransactionsColor" @click="(goToPage('transactions'),showCalendar=true)">
                            <v-list-tile-action><v-icon small color="green lighten-1">dashboard</v-icon></v-list-tile-action>
                            <v-list-tile-content>
                            <v-list-tile-title class="body-2 font-weight-regular">Branch Transactions</v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>

                        <v-list-tile :class="WalkinTransactionsColor" @click="(goToPage('walk-in-transactions'),showCalendar=false)">
                            <v-list-tile-action><v-icon small color="green lighten-1">directions_walk</v-icon></v-list-tile-action>
                            <v-list-tile-content>
                            <v-list-tile-title class="body-2 font-weight-regular">Walk-in Transactions</v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>

                        <v-list-tile :class="MechanicAssignmentColor" @click="(goToPage('mechanic-assignment'),showCalendar=false)">
                            <v-list-tile-action><v-icon small color="green lighten-1">assignment_ind</v-icon></v-list-tile-action>
                            <v-list-tile-content>
                            <v-list-tile-title class="body-2 font-weight-regular">Mechanic Assignment</v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>

                        <v-list-tile :class="CalendarManagementColor" @click="goToPage('calendar-management'),showCalendar=false">
                            <v-list-tile-action><v-icon small color="green lighten-1">event</v-icon></v-list-tile-action>
                            <v-list-tile-content>
                            <v-list-tile-title class="body-2 font-weight-regular">Calendar Management</v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <br>
                        <v-divider></v-divider>
                    </v-container>
                </v-list>
            </v-navigation-drawer>

            <v-content>
                <v-layout>
                    <v-flex>
                        <router-view/>
                    </v-flex>
                </v-layout>
            </v-content>
		</v-app>
	</div>
</template>

<script>
import firebase from "firebase"
import "../../node_modules/firebaseui/dist/firebaseui.css"
import { db } from '../main.js'
import { mapGetters, mapActions } from "vuex"
import moment from 'moment'
import _ from 'lodash'

export default {
	data() {
        return {
            branchId: "",
            branch: "",
            branchCode: "",
            drawer : true,
            picker: moment().utcOffset('+0800').toISOString().substr(0, 10),
            allowedDates: null,
            weekends: null,
            timeout: 10000,
            showCalendar: false,
            role: "",
            title: window.location.pathname,
            RequestAppointmentColor: "",
            BranchTransactionsColor: "",
            WalkinTransactionsColor: "",
            MechanicAssignmentColor: "",
            CalendarManagementColor: "",
            ExportTransactionsColor: "",
            requests: [],
        }
    },

    methods : {
        goToPage(page) {
            this.$router.push("/"+page)
        },

        async getAssign() {
            let self = this
            let process = 0
            self.dialog = true
            await firebase.auth().onAuthStateChanged(function(user) {
                db.collection("Users"+self.$stage).doc(user.uid)
                .onSnapshot(async function(doc) {
                    self.branchId = doc.data().assignId
                    self.branch = doc.data().assign.split('_')[1].trim()
                    self.branchCode = doc.data().assign.split('_')[0].trim()
                    self.role = doc.data().role
                    process++
                    if(process > 0) {
                        await self.fetchTransactions()
                    }
                })
            })
        },

        async fetchTransactions() {
            let self = this

            await db.collection("ServiceBooking"+self.$stage)
            .where("branchId","==", self.branchId)
            .where("status","==","ForApproval")
            .onSnapshot(function(querySnapshot) {
               self.requests = []
                querySnapshot.forEach(function(doc) {
                    self.requests.push(doc.data())
                })
            })
        },

        calendarValidation() {
            this.allowedDates = val =>
            ![0].includes(new Date(val).getDay()) 
        }
    },

    async mounted() {
        let self = this
        await this.getAssign()
        this.calendarValidation()
        self.$store.dispatch("setDate", this.picker)

        if(this.$route.path == "/service-approval"){
            this.RequestAppointmentColor= "blue-grey darken-3"
            this.BranchTransactionsColor= "blue-grey darken-4"
            this.WalkinTransactionsColor= "blue-grey darken-4"
            this.MechanicAssignmentColor= "blue-grey darken-4"
            this.CalendarManagementColor= "blue-grey darken-4"
            this.ExportTransactionsColor= "blue-grey darken-4"
        } else if(this.$route.path == "/transactions"){
            this.showCalendar=true
            this.RequestAppointmentColor= "blue-grey darken-4"
            this.BranchTransactionsColor= "blue-grey darken-3"
            this.WalkinTransactionsColor= "blue-grey darken-4"
            this.MechanicAssignmentColor= "blue-grey darken-4"
            this.CalendarManagementColor= "blue-grey darken-4"
            this.ExportTransactionsColor= "blue-grey darken-4"
        } else if(this.$route.path == "/walk-in-transactions"){
            this.RequestAppointmentColor= "blue-grey darken-4"
            this.BranchTransactionsColor= "blue-grey darken-4"
            this.WalkinTransactionsColor= "blue-grey darken-3"
            this.MechanicAssignmentColor= "blue-grey darken-4"
            this.CalendarManagementColor= "blue-grey darken-4"
            this.ExportTransactionsColor= "blue-grey darken-4"
        } else if(this.$route.path == "/mechanic-assignment"){
            this.RequestAppointmentColor= "blue-grey darken-4"
            this.BranchTransactionsColor= "blue-grey darken-4"
            this.WalkinTransactionsColor= "blue-grey darken-4"
            this.MechanicAssignmentColor= "blue-grey darken-3"
            this.CalendarManagementColor= "blue-grey darken-4"
            this.ExportTransactionsColor= "blue-grey darken-4"
        } else if(this.$route.path == "/calendar-management"){
            this.RequestAppointmentColor= "blue-grey darken-4"
            this.BranchTransactionsColor= "blue-grey darken-4"
            this.WalkinTransactionsColor= "blue-grey darken-4"
            this.MechanicAssignmentColor= "blue-grey darken-4"
            this.CalendarManagementColor= "blue-grey darken-3"
            this.ExportTransactionsColor= "blue-grey darken-4"
        }
    },

    computed : {
        ...mapGetters(["user"]),
    },

    watch: {
        $route (to){
            console.log(to.path)
        },

        picker(val) {
            this.$store.dispatch("setDate", val).then(() => {	
                this.calendarValidation()
            })
        },

        $route(val) {
            if(val.path == "/service-approval"){
                this.RequestAppointmentColor= "blue-grey darken-3"
                this.BranchTransactionsColor= "blue-grey darken-4"
                this.WalkinTransactionsColor= "blue-grey darken-4"
                this.MechanicAssignmentColor= "blue-grey darken-4"
                this.CalendarManagementColor= "blue-grey darken-4"
                this.ExportTransactionsColor= "blue-grey darken-4"
            } else if(val.path == "/transactions"){
                this.RequestAppointmentColor= "blue-grey darken-4"
                this.BranchTransactionsColor= "blue-grey darken-3"
                this.WalkinTransactionsColor= "blue-grey darken-4"
                this.MechanicAssignmentColor= "blue-grey darken-4"
                this.CalendarManagementColor= "blue-grey darken-4"
                this.ExportTransactionsColor= "blue-grey darken-4"
            } else if(val.path == "/walk-in-transactions"){
                this.RequestAppointmentColor= "blue-grey darken-4"
                this.BranchTransactionsColor= "blue-grey darken-4"
                this.WalkinTransactionsColor= "blue-grey darken-3"
                this.MechanicAssignmentColor= "blue-grey darken-4"
                this.CalendarManagementColor= "blue-grey darken-4"
                this.ExportTransactionsColor= "blue-grey darken-4"
            } else if(val.path == "/mechanic-assignment"){
                this.RequestAppointmentColor= "blue-grey darken-4"
                this.BranchTransactionsColor= "blue-grey darken-4"
                this.WalkinTransactionsColor= "blue-grey darken-4"
                this.MechanicAssignmentColor= "blue-grey darken-3"
                this.CalendarManagementColor= "blue-grey darken-4"
                this.ExportTransactionsColor= "blue-grey darken-4"
            } else if(val.path == "/calendar-management"){
                this.RequestAppointmentColor= "blue-grey darken-4"
                this.BranchTransactionsColor= "blue-grey darken-4"
                this.WalkinTransactionsColor= "blue-grey darken-4"
                this.MechanicAssignmentColor= "blue-grey darken-4"
                this.CalendarManagementColor= "blue-grey darken-3"
                this.ExportTransactionsColor= "blue-grey darken-4"
            }
        },
    }
}
</script>

<style scoped>

</style>

